import { type BaseApiContract } from "shared/api/BaseApiContract";
import { HttpMethod } from "shared/api/http";
import { type SocietyWorkflowParamsInput } from "shared/api/types/society/[societyId]/workflow/[workflowId]";
import { type SocietyWorkflowInstanceBodyInput } from "shared/api/types/society/[societyId]/workflow/[workflowId]/instance";
import { type WorkflowInstanceStopped } from "shared/workflow/workflow-instance";
export const postSocietyWorkflowInstanceContract: BaseApiContract<
  SocietyWorkflowParamsInput,
  SocietyWorkflowInstanceBodyInput,
  WorkflowInstanceStopped
> = {
  method: HttpMethod.POST,
  apiRoute: "/api/v1/society/[societyId]/workflow/[workflowId]/instance",
  paramsType: {} as SocietyWorkflowParamsInput,
  bodyType: {} as SocietyWorkflowInstanceBodyInput,
  responseType: {} as WorkflowInstanceStopped,
};
export const patchSocietyWorkflowInstanceContract: BaseApiContract<
  SocietyWorkflowParamsInput,
  SocietyWorkflowInstanceBodyInput,
  void
> = {
  method: HttpMethod.PATCH,
  apiRoute: "/api/v1/society/[societyId]/workflow/[workflowId]/instance",
  paramsType: {} as SocietyWorkflowParamsInput,
  bodyType: {} as SocietyWorkflowInstanceBodyInput,
  responseType: undefined as unknown as void,
};
